<template>
  <el-header height="46px" :style="{ background: $root.headerColor }">
    <!-- <h4>IBM AICC Watson AI Assistant</h4> -->
    <h4 :style="{ color: $root.fontColor }">{{ $root.htmlConst.cons_229_header_dashboard }}</h4>
    <section class="header-info">
      <Time></Time>
      <div class="user" :style="{ color: $root.fontColor }">
        <el-avatar :size="32" :src="logoUrl"></el-avatar>
        <div class="name" :style="{ color: $root.fontColor }">
          <!-- <p v-for="name in userName.split(' ')" :key="name">{{ name }}</p> -->
          <p>{{ userName }}</p>
          <div class="role">{{ role }}</div>
        </div>
      </div>
      <div class="action phone-action" :style="{ color: $root.fontColor }">
        <div :class="[phoneBlingbling ? 'blingbling' : 'notBlingbling']">
          <el-tooltip class="item" effect="dark" content="電話" placement="bottom">
            <span @click="showPhoneDialog">
              <font-awesome-icon :icon="['fas', 'phone']" />
            </span>
          </el-tooltip>
        </div>
      </div>
      <div class="action" :style="{ color: $root.fontColor }" :class="{ disabled: $root.activeName == 'voice_log' }">
        <el-tooltip class="item" effect="dark" content="settings" placement="bottom">
          <span @click="editModeFunc">
            <!-- <icon v-if="$root.editMode" data="@assetsIcon/check.svg" width="1.25rem" height="1.25rem" />
            <icon v-else data="@assetsIcon/settings.svg" width="1.25rem" height="1.25rem" /> -->
            <icon v-if="$root.editMode && $root.activeName != 'history'" name="check"/>
            <icon v-else name="settings"/>
          </span>
        </el-tooltip>
      </div>
      <div class="action" :style="{ color: $root.fontColor }">
        <el-tooltip class="item" effect="dark" content="ログアウト" placement="bottom">
          <span class="logout-icon" @click="logoutConfirm">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- ドアの枠 -->
              <rect x="3" y="3" width="9" height="18" rx="1.5" stroke="currentColor" stroke-width="2" fill="none" />
              <!-- ドアの開いた部分（右側の線） -->
              <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" stroke-width="2" />
              <!-- 右向き矢印 -->
              <path d="M13.5 12 L19.5 12 M16.5 9 L19.5 12 L16.5 15" stroke="currentColor" stroke-width="2" fill="none"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </el-tooltip>
      </div>
    </section>
    <el-dialog title="logout" class="logoutDialog" :append-to-body="true" :visible.sync="dialogVisible" width="30%"
      style="margin-top: 5vh !important">
      <span style="padding: 0 20px;">{{ $root.htmlConst.cons_228_logout_message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logout" class="is-red">
          {{ $root.htmlConst.cons_143_button_ok }}
        </el-button>
        <el-button @click="dialogVisible = false" type="primary" plain class="is-blue">
          {{ $root.htmlConst.cons_144_button_cancel }}
        </el-button>
      </span>
    </el-dialog>
  </el-header>
</template>

<script>
import api from "@/api";
import Time from "@/components/Time.vue";
export default {
  name: "CommonHeader",
  components: {
    Time,
  },
  data() {
    return {
      userName: "",
      dialogVisible: false,
      logoUrl: "https://cloud.ibm.com/avatar/v1/avatar/migrate-bluemix-photos-production/a62e0052-a264-45e0-aed7-5fe269f5a250.jpg",
      sipConfig: {},
      userRole:"",
    };
  },
  watch: {
    sipConnect(newValue) {
      if (newValue) {
        this.connectSip()
      }
    }

  },
  computed: {
    sipConnect() {
      if (this.$root.user && this.$root.user.tel_num && this.sipConfig.sip_domain) {
        return true
      } else {
        return false
      }
    },
    role(){
      return this.userRole == 'supervisor'? 'SV':(this.userRole == 'operator'?'OP':'')
    },
    phoneBlingbling() {
      return this.$store.state.phone.callList.filter(item => item.isWaiting && item.is_outbound == '0').length > 0 
    }
  },
  created() {
    api.getSeviceUrl().then(
      (res) => {
        if (res && res.data) {
          let data = res.data;
          this.$root.websocketUrl = data.url.websocketUrl;
          this.$root.redmineUrl = data.url.redmineUrl;
          api.getUserInfo().then(
            (res) => {
              if (res && res.data) {
                let data = res.data;
                this.userName = data.user.name;
                this.logoUrl = data.user.logo_url;
                this.userRole = data.user.role;
                this.$root.user = data.user;
                console.log('')
                let websocketUrl =
                  this.$root.websocketUrl +
                  "/monitorInfo?userId=" +
                  this.$root.user.user_id;
                console.log(websocketUrl);
                this.createWebSocket(websocketUrl);
              }
            },
            (err) => {
              console.log(err);
            }
          );
        }
      },
      (err) => {
        console.log(err);
      }
    );
    this.getSipConfig()
    this.getSystemConfig()
    api.getHtmlConstRecording().then(
      (res) => {
        if (res && res.data) {
          let data = res.data;
          this.$root.htmlConstRecording = data.htmlConst;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    editModeFunc() {
      if(this.$root.activeName == 'history'){
        this.$root.showHistorySetting = !this.$root.showHistorySetting
        return 
      }
      this.$root.editMode = !this.$root.editMode;
      if (this.$root.editMode == true) {
        if (this.$root.historyChatShowFlg == true) {
          this.$root.historyChatHeight = '100%';
        } else if (this.$root.historyChatShowFlg == false) {
          this.$root.historyChatHeight = '635px';
        }
      } else if (this.$root.editMode == false) {
        if (this.$root.historyChatShowFlg == true) {
          this.$root.historyChatHeight = '100%';
        } else if (this.$root.historyChatShowFlg == false) {
          if (this.$root.allBarShowFlg == true) {
            this.$root.historyChatHeight = '460px';
          } else if (this.$root.allBarShowFlg == false) {
            this.$root.historyChatHeight = '600px';
          }
        }
      }
    },
    logoutConfirm() {
      this.dialogVisible = true;
    },
    logout() {
      api.logout().then(
        (res) => {
          sessionStorage.clear()
          const logoutUrl = res.data.logoutUrl; 
          window.location.href = logoutUrl;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    createWebSocket(url) {
      var statusWs = null;
      var statusLockReconnect = false;
      var that = this;
      try {
        if ("WebSocket" in window) {
          statusWs = new WebSocket(url);
        }
        let heartCheck = {
          timeout: 1000,
          timeoutObj: null,
          serverTimeoutObj: null,
          reset: function () {
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            return this;
          },
          start: function () {
            let self = this;
            this.timeoutObj = setTimeout(function () {
              if (statusWs != null && statusWs.readyState == 1) {
                statusWs.send("ping");
              }
              self.serverTimeoutObj = setTimeout(function () {
                // if(statusWs != null && statusWs.readyState == 3){
                //   statusWs.close();
                // }
              }, self.timeout);
            }, this.timeout);
          },
        };
        statusWs.onclose = function (event) {
          if (statusLockReconnect) return;
          statusLockReconnect = true;
          setTimeout(function () {
            that.createWebSocket(url);
            statusLockReconnect = false;
          }, 2000);
          console.log("status websocket close event:", event);
        };
        statusWs.onerror = function (err) {
          if (statusLockReconnect) return;
          statusLockReconnect = true;
          setTimeout(function () {
            that.createWebSocket(url);
            statusLockReconnect = false;
          }, 2000);
          console.log("status websocket err:", err);
        };
        statusWs.onopen = function () {
          heartCheck.reset().start();
          console.log("status websocket open.");
        };
        statusWs.onmessage = function (event) {
          heartCheck.reset().start();
          if (event.data != "pong") {
            console.log("websocket data", JSON.parse(event.data));
            let message = JSON.parse(event.data);
            if (message.type === 'STOP_MONITORING') {
              // 要求停止监听
              let currentUser = that.$root.user.user_id;
              let targetUser = message.data.userId;
              // 当前登录用户是被要求停止监听的对象
              if (currentUser == targetUser) {
                console.log(`当前用户${currentUser}在UC2上面接听电话，UC3上面的电话监听被终止`);
                console.log(that.$SIP);
                let dialNum = '555'.concat(message.data.monitoringTelNum);
                that.$SIP.endSession(dialNum);
                that.$store.state.startMonitoring = false
              }
            } else {
              // 要求刷新数据

              if (that.$root.activeName == "presence") {
                api.getPresenceTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data && res.data.output_list) {
                      let data = res.data;
                      that.$root.presenceTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.groupFilters.map((v) => v.value).includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.groupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (!that.$root.svFilters.map((v) => v.value).includes(role)) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.svFilters.push(svFilter);
                        }
                      }
                      for (let model of data.output_list.map((v) => v.model)) {
                        let modelFilter = {};
                        if (!that.$root.modelFilters.map((v) => v.value).includes(model)) {
                          modelFilter.text = model;
                          modelFilter.value = model;
                          that.$root.modelFilters.push(modelFilter);
                        }
                      }
                      // ==========================================
                      // 修正日時: 2026-01-22
                      // 修正内容: 応対不可ステータスのフィルター条件からの除外
                      //           - .envの設定（VUE_APP_EXCLUDE_OFFLINE_STATUS）で除外制御
                      //           - データ更新時にもフィルター選択肢から応対不可を除外
                      // ==========================================
                      // .envの設定で除外するかどうかを制御
                      const excludeOffline = process.env.VUE_APP_EXCLUDE_OFFLINE_STATUS !== 'false';
                      const offlineStatus = that.$root.htmlConst?.cons_168_status_offline;
                      if (excludeOffline && offlineStatus) {
                        // 既存のフィルターリストから「応対不可」を削除
                        that.$root.statusFilters = that.$root.statusFilters.filter(
                          (filter) => filter.value !== offlineStatus
                        );
                      }
                      for (let presence of data.output_list.map((v) => v.presence)) {
                        // .envの設定に基づいて「応対不可」をフィルター条件から除外
                        if (excludeOffline && presence === offlineStatus) {
                          continue;
                        }
                        let statusFilter = {};
                        if (
                          !that.$root.statusFilters.map((v) => v.value).includes(presence)
                        ) {
                          statusFilter.text = presence;
                          statusFilter.value = presence;
                          that.$root.statusFilters.push(statusFilter);
                        }
                      }
                      that.$root.presenceNgCount = data.ngCount;
                      // that.$root.presenceLongTimeCount = data.longTimeCount;
                      that.$root.presenceSVDependCount = data.svDependCount;
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                // ==========================================
                // 修正日時: 2026-01-26
                // 修正内容: TelDetailTableとのマージ - WebSocket更新時にtelRealTimeTableDataも取得
                //           - PresenceDetailTableでtelRealTimeTableDataを表示するため
                // ==========================================
                api.getTelRealTimeTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      that.$root.telRealTimeTableData = res.data.output_list;
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getPresenceMode().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.presenceModeChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                // F2F
                                "#0086B5",
                                // Chat
                                "#94E3FF",
                                // TEL
                                "#55BFE7",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.presenceModeChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getPresenceStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.presenceStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                "#007bff",
                                "#67C23A",
                                "#ffc107",
                                "#DDDDDD",
                                "#888888",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.presenceStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              } else if (that.$root.activeName == "chat") {
                api.getChatRealTimeTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.chatRealTimeTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.chatRealTimeGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.chatRealTimeGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.chatRealTimeSvFilters
                            .map((v) => v.value)
                            .includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.chatRealTimeSvFilters.push(svFilter);
                        }
                      }
                      for (let presence of data.output_list.map((v) => v.presence)) {
                        let statusFilter = {};
                        if (
                          !that.$root.chatRealTimeStatusFilters
                            .map((v) => v.value)
                            .includes(presence)
                        ) {
                          statusFilter.text = presence;
                          statusFilter.value = presence;
                          that.$root.chatRealTimeStatusFilters.push(statusFilter);
                        }
                      }
                      that.$root.chatNgCount = data.ngCount;
                      that.$root.chatSVDependCount = data.svDependCount;
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getChatDailyTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.chatDailyTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.chatDailyGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.chatDailyGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.chatDailySvFilters.map((v) => v.value).includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.chatDailySvFilters.push(svFilter);
                        }
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getChatPersonStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.chatPersonStatusOption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#007bff", "#67C23A", "#888888"],
                            },
                          ],
                        };
                      } else {
                        that.$root.chatPersonStatusOption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getChatStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.chatStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                "#007bff",
                                "#67C23A",
                                "#ffc107",
                                "#DDDDDD",
                                "#888888",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.chatStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getChatAnswerStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.chatAnswerStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                "#dc3545",
                                "#ffc107",
                                "#BBBB00",
                                "#67C23A",
                                "#007bff",
                                "#888888",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.chatAnswerStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              } else if (that.$root.activeName == "tel") {
                api.getTelRealTimeTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.telRealTimeTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.telRealTimeGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.telRealTimeGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.telRealTimeSvFilters
                            .map((v) => v.value)
                            .includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.telRealTimeSvFilters.push(svFilter);
                        }
                      }
                      for (let presence of data.output_list.map((v) => v.presence)) {
                        let statusFilter = {};
                        if (
                          !that.$root.telRealTimeStatusFilters
                            .map((v) => v.value)
                            .includes(presence)
                        ) {
                          statusFilter.text = presence;
                          statusFilter.value = presence;
                          that.$root.telRealTimeStatusFilters.push(statusFilter);
                        }
                      }
                      that.$root.telNgCount = data.ngCount;
                      // that.$root.telLongTimeCount = data.longTimeCount;
                      that.$root.telSVDependCount = data.svDependCount;
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getTelDailyTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.telDailyTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.telDailyGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.telDailyGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.telDailySvFilters.map((v) => v.value).includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.telDailySvFilters.push(svFilter);
                        }
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getTelStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.telStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                "#007bff",
                                "#67C23A",
                                "#28a745",
                                "#ffc107",
                                "#DDDDDD",
                                "#888888",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.telStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getReleaseStatusChart().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.releaseStatsChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: [
                                //浅绿
                                "#67C23A",
                                //深绿
                                "#28a745",
                                //红
                                "#dc3545",
                                //深黄
                                "#ffc107",
                                //浅黄
                                "#BBBB00",
                              ],
                            },
                          ],
                        };
                      } else {
                        that.$root.releaseStatsChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              } else {
                api.getF2FRealTimeTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.f2fRealTimeTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.f2fRealTimeGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.f2fRealTimeGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.f2fRealTimeSvFilters
                            .map((v) => v.value)
                            .includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.f2fRealTimeSvFilters.push(svFilter);
                        }
                      }
                      for (let presence of data.output_list.map((v) => v.presence)) {
                        let statusFilter = {};
                        if (
                          !that.$root.f2fRealTimeStatusFilters
                            .map((v) => v.value)
                            .includes(presence)
                        ) {
                          statusFilter.text = presence;
                          statusFilter.value = presence;
                          that.$root.f2fRealTimeStatusFilters.push(statusFilter);
                        }
                      }
                      that.$root.f2fNgCount = data.ngCount;
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getF2FDailyTableDetail(that.$root.user.user_id).then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      that.$root.f2fDailyTableData = data.output_list;
                      for (let groupName of data.output_list.map((v) => v.groupName)) {
                        let groupNameFilter = {};
                        if (
                          !that.$root.f2fDailyGroupFilters
                            .map((v) => v.value)
                            .includes(groupName)
                        ) {
                          groupNameFilter.text = groupName;
                          groupNameFilter.value = groupName;
                          that.$root.f2fDailyGroupFilters.push(groupNameFilter);
                        }
                      }
                      for (let role of data.output_list.map((v) => v.role)) {
                        let svFilter = {};
                        if (
                          !that.$root.f2fDailySvFilters.map((v) => v.value).includes(role)
                        ) {
                          svFilter.text = role;
                          svFilter.value = role;
                          that.$root.f2fDailySvFilters.push(svFilter);
                        }
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
                api.getF2FStatus().then(
                  (res) => {
                    if (res && res.data) {
                      let data = res.data;
                      if (data.dataFlg) {
                        that.$root.f2fStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#007bff", "#28a745"],
                            },
                          ],
                        };
                      } else {
                        that.$root.f2fStatusChartoption = {
                          tooltip: {
                            trigger: "item",
                            formatter: "{b} : {c} ({d}%)",
                          },
                          series: [
                            {
                              type: "pie",
                              radius: "55%",
                              center: ["50%", "47%"],
                              data: data.output_list,
                              labelLine: {
                                length: 3,
                              },
                              itemStyle: {
                                emphasis: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                              },
                              color: ["#DDDDDD"],
                            },
                          ],
                        };
                      }
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              }
            }
          }
        };
      } catch (e) {
        if (statusLockReconnect) return;
        statusLockReconnect = true;
        setTimeout(function () {
          that.createWebSocket(url);
          statusLockReconnect = false;
        }, 2000);
        console.log("status websocket create err:", e);
      }
    },
    getSipConfig() {
      api.getSipConfig().then((res) => {
        if (res && res.data) {
          this.sipConfig = res.data
          console.log('this.sipConfig...', this.sipConfig)
        }
      },
        (err) => {
          console.log(err);
        })
    },
    connectSip() {
      console.log("connectSip.....")
      let sipConfig = {
        SipUsername: this.$root.user.tel_num,
        // SipUsername: '01006',
        SipDomain: this.sipConfig.sip_domain,
        SipPassword: this.sipConfig.sip_pw,
        wssServer: this.sipConfig.sip_wss_server,
        WebSocketPort: this.sipConfig.sip_websocket_port,
        ContactUserName: '',
        // profileName:'01006',
        profileName: this.$root.user.tel_num,
        ServerPath: this.sipConfig.sip_server_path,
        NoAnswerTimeout: 8 * 60 * 60 
      }
      console.log('sipConfig....', sipConfig)
      this.$SIP.initPhone(sipConfig);
    },
    showPhoneDialog() {
      this.$store.dispatch('phone/setShowPhone', !this.$store.state.phone.showPhone);
    },
    //2026-03-13 get long time from DB at first 
    getSystemConfig(){
      api.getSystemConfig().then((res) => {
        if (res && res.data && res.data.data) {
          let uc3Configs = res.data.data
          if(uc3Configs.length>0){
            let longTimeConfig = uc3Configs.find(config => config.func_name == "LONG_TIME_CALL")
            this.$root.longTimeConfig =  Number(longTimeConfig?.value) || 2
          } 
        }
      },
        (err) => {
          console.log(err);
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  display: flex;
  align-items: center;
  // background-image: linear-gradient(90deg, #5aaafa 0, #41d6c3);
  padding: 0 0 0 10px;
  justify-content: space-between;

  h4 {
    font-size: 0.875rem;
    font-weight: normal;
    color: #fff;
  }

  .user {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;

    .avatar {
      width: 45px;
      height: 45px;
      padding: 6px;

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #fff;
      }
    }

    .name {
      word-break: break-all;

      p {
        margin: 0;
      }
      // max-width: 100px;
      min-width: 50px;
      // min-width: 30px;
      // font-size: 0.75rem;
      font-size: 0.625rem;
      color: #fff;
      margin: 0 0px 0 10px;
      line-height: 14px;
      display: flex;
    }
    .role{
      margin-left: 4px;
    }
  }

  .header-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 300px;
    font-weight: bold;
    padding-right: 20px;
  }

  .action {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;

    svg,
    span {
      // margin: 0 20px 0 0;
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .el-input__clear {
    color: white;
  }
}

.logoutDialog {
  :deep(.el-dialog__header) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #5abce4;
    padding: 10px;
    border-radius: 2px 2px 0 0;
    margin-bottom: 20px;
  }

  :deep(el-dialog__body) {
    padding: 20px 10px !important;
  }

  :deep(.el-dialog__headerbtn) {
    position: static
  }
}


.logout-btn {
  color: #f56c6c;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  margin: 0 auto;

  &:hover {
    color: #f78989;
  }

  .logout-icon {
    margin-right: 6px;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }

  .logout-text {
    display: inline-block;
    line-height: normal;
    vertical-align: middle;
  }

  i {
    margin-right: 5px;
  }
}
.phone-action {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .blingbling {
    -webkit-animation: phone-scaleout 1.5s infinite ease-in-out;
    animation: phone-scaleout 1.5s infinite ease-in-out;
    color: red !important;
  }

  .notBlingbling {
    // 正常状態
  }

  @-webkit-keyframes phone-scaleout {
    0% {
      -webkit-transform: scale(1.0);
    }
    100% {
      -webkit-transform: scale(1.1);
      opacity: 0.6;
    }
  }

  @keyframes phone-scaleout {
    0% {
      transform: scale(1.0);
      -webkit-transform: scale(1.0);
    }
    100% {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
      opacity: 0.6;
    }
  }
}

.action.disabled span {
  pointer-events: none;
}

.action.disabled {
  cursor: not-allowed;
}
</style>
